<template>
  <div>
    <QS-h4-title title="付款基础信息" />
    <el-form label-width="140px">
      <column-box
        :source="source"
        :list="list"
        :column="3"
        :label-width="130"
      >
        <el-form-item
          :label="'付款凭证' + columnSeparator"
          class="btom"
          label-width="130px"
        >
          <EnlargeImg :imgSrc="source.photo" />
        </el-form-item>
         <!-- 财务审批 需求中新增 字段 doc: https://bailongma.yuque.com/hhwu0d/yizg52/niomzpf77bxv6oog#sRRue -->
      </column-box>
    </el-form>
  </div>
</template>
<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    source: {
      handler(val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.source.stateName = selectOption.collectionStateList[val.state]
        // eslint-disable-next-line vue/no-mutating-props
        this.source.payeeTypeName = selectOption.customerTypeDict[val.payeeType]
      },
      deep: true,
    },
  },
  data() {
    return {
      list: [
        {
          key: 'id',
          name: '付款单ID',
        },
        {
          key: 'stateName',
          name: '付款单状态',
        },
        {
          key: 'gmtCreate',
          name: '创建时间',
        },
        {
          key: 'completeTime',
          name: '完成时间',
        },
        {
          key: 'discardTime',
          name: '作废时间',
        },
        {
          key: 'amount',
          name: '付款金额',
        },
        {
          key: 'batchPaymentId',
          name: '批量付款ID',
        },
        {
          key: 'payeeTypeName',
          name: '收款方类型',
        },
        {
          key: 'payee',
          name: '收款方',
        },
        {
          key: 'remarks',
          name: '备注',
        },
        {
          key: 'discardReason',
          name: '作废原因备注',
        },
      ],
    }
  },
  created() {
    // eslint-disable-next-line vue/no-mutating-props
    this.source.stateName = selectOption.collectionStateList[this.source.state]
    // eslint-disable-next-line vue/no-mutating-props
    this.source.payeeTypeName = selectOption.customerTypeDict[this.source.payeeType]
  },
}
</script>
<style lang="scss" scoped>
img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}
::v-deep .el-form-item .el-form-item__content {
  margin-left: 0 !important;
}
</style>
